import React from 'react';
import './CalculatorPage.css'; 

// Importing necessary components
import { Calculator, PageTitle } from '../../../components';



const CalculatorPage = () => { 

  return (
    <div className='calculator-page'>

      {/* Page Title Section */}
      <PageTitle title={'Solar Calculator'} page={'Solar Calculator'} /> 

      {/* Loan Calculator Component */}
      <Calculator />

    </div>
  );
}

export default CalculatorPage;